export function preventNonNumberInput(event: KeyboardEvent): void {
  // Firefox number type input allows letters which we don't want
  const charCode = event.key;

  const isComma = charCode === ',';
  const isDecimal = charCode === '.' || charCode === 'Decimal';

  if (
    isNaN(+charCode) &&
    !isComma &&
    !isDecimal &&
    charCode !== 'Backspace' &&
    charCode !== 'Delete' &&
    charCode !== 'ArrowLeft' &&
    charCode !== 'ArrowRight'
  ) {
    event.preventDefault();
  }
}
